import {
  IServerSideGetRowsRequest,
  LoadSuccessParams,
} from 'ag-grid-community';
import { createAction, props } from '@ngrx/store';

import { User } from 'src/app/core/models/core.models';

export const loadAdminUsersGridData = createAction(
  '[Admin Users] Load Data',
  props<{ params: IServerSideGetRowsRequest }>(),
);

export const loadAdminUsersGridDataSuccess = createAction(
  '[Admin Users] Data Loaded',
  props<{ agGridParams: LoadSuccessParams }>(),
);

export const loadAdminUsersGridDataFailure = createAction(
  '[Admin Users] Data Load Failure',
  props<{ error: any }>(),
);

export const pageChange = createAction(
  '[Admin Users] Page Change',
  props<{ page: number }>(),
);

export const setAdminCurentUser = createAction(
  '[Users] Set Admin Current User',
  props<{ user: User }>(),
);

/**
 * Pure broadcast from `injectManageUserMutation`'s onSuccess. Its one consumer is
 * `auth.reducer`, which merges a self-edit into the signed-in user; the admin
 * Users grid mirrors the write from the mutation cache instead
 * (`injectUserWriteStates`).
 */
export const editUserSuccess = createAction(
  '[Admin Users] Edit User Success',
  props<{ userData: User }>(),
);
